<template>
  <div class="workflow-transaction-details main">
    <div class="wrapper" :class="{ 'bg-test': isTest }" v-if="t">
      <p class="header" :class="`bg-${t.workflow_type_name}`">
        <span @click="close">
          <i class="fa fa-chevron-left" style="padding-right: 8px" />
          {{ t.workflow_type_name }}
        </span>
        <span class="tag align-top">
          {{ shortState }}
        </span>
        <span v-if="showRetryDelivery" class="link has-text-success align-top" style="font-size: 0.8em; margin-left: 6px"
          @click="retryDelivery">Retry</span>
        <span class="tag is-dark is-pulled-right" @click="copyTransactionID">
          ID {{ lastFive(t.id) }}
        </span>
      </p>
      <div class="table-wrapper no-scrollbar">
        <div v-if="isTest" class="notification is-danger" style="margin-bottom: 6px; padding: 10px">
          This is a TEST order
        </div>
        <div v-if="t.is_deleted" class="notification is-danger" style="margin-bottom: 6px; padding: 10px">
          DELETED
          <span class="is-pulled-right link" @click="undelete">Undo Delete</span>
        </div>
        <p v-show="retrying" class="calling">Retrying...</p>

        <div class="call-wrapper">
          <p v-if="isCommerce" class="is-flex" style="gap: 6px">
            <span style="flex-shrink: 1">
              <i class="fa fa-store-alt fa-sm has-text-grey" />
              <span class="link" @click="showShopDetails = true">Shop</span>
            </span>
            <span v-if="!isSilentShop" class="tag is-black has-text-warning is-rounded" style="flex: 1"
              @click="notifyShop">&nbsp;<i class="fa fa-bullhorn" />&nbsp;</span>
            <span class="tag is-rounded" :class="t.data.call_shop > 0 ? 'is-danger' : 'is-warning'" @click="callShop"
              style="flex: 1">Called&nbsp;x&nbsp;<b>{{ t.data.call_shop || 0 }}</b>
            </span>
            <a @click="callShop">{{
              t.data.business.phone_number || "No Phone"
            }}</a>
          </p>
          <p>
            <i class="fa fa-user fa-sm has-text-grey" />
            <span class="link" @click="goto('user_info/' + t.created_by)">Customer</span>
            <span v-if="isCommerce && t.data.order.local_contact" class="tag is-danger has-text-weight-bold"
              style="margin-left: 6px" @click="copyLocalContact">Contact: {{ t.data.order.local_contact }}</span>
            <a class="is-pulled-right" @click="callCustomer">{{
              t.customer.phone_number
            }}</a>
          </p>
          <p v-if="!isCommerce && t.driver">
            <i class="fa fa-motorcycle fa-sm has-text-grey" />
            <span class="link" @click="goto('user_info/' + t.handled_by)">Driver</span>
            <a class="is-pulled-right" @click="callDriver">{{
              t.driver.phone_number
            }}</a>
          </p>
          <p v-if="isCommerce">
            <i class="fa fa-receipt fa-sm has-text-grey" />
            <span class="link" @click="goto(`commerce_order/${t.id}`)">Order #{{ t.data.ref }}
            </span>
            <a class="is-pulled-right" @click="goto(`commerce_agent_order/${t.id}`)">Agent View<i
                class="fa fa-external-link-alt" /></a>
          </p>
        </div>
        <p v-if="deviceToDeliveryAddressDistance > 50" class="warning" @click="gotoDeviceLocationMapURL">
          📍 Delivery address: {{ deviceToDeliveryAddressDistance }}m 📲 device
          distance
        </p>

        <p v-if="t.data.hide_driver" class="more-info" style="background-color: yellow">
          Delivery driver is hidden
          <i class="fa fa-eye-slash is-pulled-right" />
        </p>

        <p v-show="calling" class="calling">
          Calling {{ calling }}&nbsp;
          <i class="fa fa-times-circle fa-lg is-pulled-right" style="padding: 3px" @click="calling = null" />
        </p>

        <p v-if="moreInfo" class="more-info" @click="gotoMapURL">
          {{ moreInfo }}
          <i class="fa fa-external-link-alt has-text-white is-pulled-right" />
        </p>

        <!-- Should make separate table component for each workflow type -->
        <table v-if="!isDelivery" class="table is-fullwidth">
          <tr v-for="(value, key) in prettyT" :key="key" @click="showMoreInfo(key)">
            <td class="key is-narrow">{{ key }}</td>
            <td class="value" :class="clickable(key)" v-html="value"></td>
          </tr>
        </table>
        <DeliveryDetailsTable v-if="isDelivery" :t="t" />
        <!-- <RemitDetailsTable v-if="isRemit" :t="t" /> -->
        <!-- <CommerceDetailsTable v-if="false" :t="t" /> -->

        <div>
          <span v-if="showLanguages" class="button is-pulled-right is-dark" @click="nextLang">
            <i class="fa fa-language fa-2x" />
          </span>
        </div>
      </div>

      <div class="bottom-bar">
        <div v-if="showActions" class="actions-wrapper">
          <p class="subtitle" style="padding: 12px; margin-bottom: 8px; color: white" @click="showActions = false">
            Actions
            <button class="delete is-large is-pulled-right" />
          </p>
          <div class="actions">
            <p v-if="t.is_deleted" class="has-text-danger" @click="undelete">
              <i class="fa fa-bomb has-text-success" />&nbsp;Un-Delete
              <i class="fa fa-chevron-right" />
            </p>
            <p v-else class="has-text-danger" @click="preSoftDelete">
              <i class="fa fa-bomb" />&nbsp;Delete
              <i class="fa fa-chevron-right" />
            </p>
            <p class="has-text-link" @click="showChangeState = true">
              <i class="fa fa-exchange-alt" />&nbsp;Change State
              <i class="fa fa-chevron-right" />
            </p>
            <!-- delivery  -->
            <div v-if="isDelivery">
              <p class="has-text-warning">
                <span v-if="!t.data.hide_driver" @click="hideDeliveryDriver(true)"><i
                    class="far fa-eye-slash" />&nbsp;Hide Driver</span>
                <span v-else @click="hideDeliveryDriver(false)"><i class="far fa-eye" />&nbsp;Show Driver</span>
                <i class="fa fa-chevron-right" />
              </p>
            </div>
            <!-- commerce -->
            <div v-if="isCommerce">
              <p v-if="!t.is_ongoing" class="has-text-info" @click="restartCommerce">
                <i class="fa fa-redo" />&nbsp;Restart Order
                <i class="fa fa-chevron-right" />
              </p>
              <p v-if="t.data.type === 'delivery'" class="has-text-primary" @click="preAssignDriver">
                <i class="fa fa-motorcycle" />&nbsp;Assign Driver
                <i class="fa fa-chevron-right" />
              </p>
              <p v-if="t.data.type === 'delivery'" class="has-text-success" @click="preChangeToAutoconfirm">
                <i class="far fa-hourglass" />&nbsp;Autoconfirm
                <i class="fa fa-chevron-right" />
              </p>
              <p class="has-text-success" @click="editTukDiscount">
                <i class="fa fa-percentage" />&nbsp;TUK Discount
                <i class="fa fa-chevron-right" />
              </p>
            </div>
          </div>
        </div>

        <div class="is-flex">
          <div class="button" @click="close">
            <i class="fa fa-chevron-left" />
          </div>
          <div class="button" @click="update">
            <i class="fa fa-redo-alt" />
          </div>
          <div class="button" @click="showActions = !showActions">
            <i class="fa fa-ellipsis-h" />
          </div>
        </div>
      </div>

      <CommerceDetailsShopPanel v-if="showShopDetails" :t="t" @close="showShopDetails = false" />

      <TransactionChangeStatePanel v-if="showChangeState" :t="t" @close="showChangeState = false" />
    </div>
  </div>
</template>

<script>
import { sounds } from "../functions.js";
import codes from "@/codes";
import geo from "@/geo";
import DeliveryDetailsTable from "@/components/DeliveryDetailsTable.vue";
import CommerceDetailsTable from "@/components/CommerceDetailsTable.vue";
import CommerceDetailsShopPanel from "@/components/CommerceDetailsShopPanel.vue";
import TransactionChangeStatePanel from "@/components/TransactionChangeStatePanel.vue";

export default {
  name: "WorkflowTransactionDetails",
  components: {
    DeliveryDetailsTable,
    // CommerceDetailsTable,
    CommerceDetailsShopPanel,
    TransactionChangeStatePanel,
  },
  props: {
    t: Object, // transaction
  },
  data() {
    return {
      deviceToDeliveryAddressDistance: null, // compute on mounted
      showActions: false,
      showChangeState: false,
      showShopDetails: false,
      calling: null,
      retrying: false,
      // showDelete: false,
      moreInfo: null,
      mapURL: null,
      langIdx: 0, // for commerce menu items only
      showOptions: false, // things like change driver, change state etc
      warning: null,
      silentShops: [
        "6c07ede0-a3c0-11ea-b57a-de4e22edc4b3", // staging: burrito squad
        "78e84a37-d56c-11eb-b34f-661956ab742d", // prod: Drop In Restaurant
      ],
    };
  },
  computed: {
    prettyT() {
      if (!this.t) return {};
      // if (this.isDelivery) return this.parseDelivery();
      if (this.isCommerce) return this.parseCommerce();
      return this.parseTransport();
    },
    isSilentShop() {
      // don't notify some shops hack
      return this.silentShops.includes(this.t.business_id);
    },
    isTest() {
      if (!this.t) return false;
      return JSON.stringify(this.t.data).includes("TEST");
    },
    isCommerce() {
      if (!this.t) return false;
      return this.t.workflow_type_name === "Commerce";
    },
    isDelivery() {
      if (!this.t) return false;
      return this.t.workflow_type_name === "Delivery";
    },
    showRetryDelivery() {
      if (!this.t || !this.isDelivery) return false;
      // return this.isDelivery && this.t.state === "timed_out";
      if (this.t.state === "timed_out") return true;
      if (this.t.state === "cancelled_by_driver") return true;
      return false;
    },
    menuLanguages() {
      if (!this.isCommerce) return ["en"]; // default lang?
      if (!this.t.data.order.basket.items) return ["en"];
      if (!this.t.data.order.basket.items.length) return ["en"];
      var languages = this.t.data.order.basket.items[0].item.languages;
      if (!languages) return ["en"];
      return Object.keys(languages);
    },
    showLanguages() {
      return this.isCommerce && this.menuLanguages.length > 1;
    },
    shortState() {
      return this.t.state.replace("cancelled", "x");
    },
  },
  mounted() {
    this.checkWarnings();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    update() {
      this.infoToast("TODO: update()");
    },
    checkWarnings() {
      // commerce: check distance from device to delivery address
      if (this.isCommerce) this.checkDeviceToDeliveryAddress();
    },
    checkDeviceToDeliveryAddress() {
      if (!this.isDelivery) return;
      var a = this.t.data.coords_created;
      var b = this.t.data.address;
      var dist = geo.distanceToUserInMeters(a, b);
      if (dist > 50) {
        this.warning = `📍 Delivery address: ${dist}m 📲 device distance`;
      }
      this.deviceToDeliveryAddressDistance = dist; // new way
    },
    setDeliveryVisibility(visibility) {
      this.infoToast(`TODO ${visibility} delivery`);
    },
    changeDriver(t) {
      console.log("changeDriver", t);
    },
    hideDeliveryDriver(hideDriver) {
      if (!hideDriver) hideDriver = false;
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.t.id,
          data: { data: { hide_driver: hideDriver } },
        })
        .then(() => {
          this.$emit("update");
          this.$emit("close");
          this.infoToast(`SUCCESS hide_driver: ${hideDriver}`);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    // changeState() {
    //   var msg = `TODO manually change state<br>Like when driver forgot<br>to click enroute button`;
    //   this.infoToast(msg);
    // },
    copyTransactionID() {
      this.$copyText(this.t.id);
      this.infoToast(`Copied transaction ID<br>${this.t.id}`, "top");
    },
    copyLocalContact() {
      var contact = this.t.data.order.local_contact;
      this.$copyText(contact);
      this.infoToast(`Copied local contact<br>${contact}`, "top");
    },
    lastFive(id) {
      return id.substr(id.length - 5);
    },
    nextLang() {
      this.langIdx += 1;
      if (this.menuLanguages.length <= this.langIdx) this.langIdx = 0;
    },
    clickable(key) {
      var keys = ["Shop", "Address", "Pickup", "Dropoff", "Fare"];
      if (keys.includes(key)) return "has-text-info";
    },
    editTukDiscount() {
      var tukDiscount = this.t.data.order.tuk_discount || 0;
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class='fa fa-percentage'></i>&nbsp;Add TUK Discount<p/>
        <p style='margin-bottom:10px'>This edits the TUK Discount on commerce order.</p>
        <p><i>Current TUK Discount: <b>${tukDiscount}</b></i></p>
        </div>`,
        input: "text",
        inputPlaceholder: "฿100",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "Add TUK Discount",
        inputValidator: (val) => {
          if (!val || parseInt(val) < 0) return "Enter a discount >= 0";
        },
      }).then((val) => {
        if (!val.value) return;
        var discount = parseInt(val.value);
        this.infoToast("Setting TUK Discount to ฿" + discount);
        var data = {
          id: this.t.id,
          discount: discount,
        };
        var loader = this.loadingDots("orange");
        this.$store
          .dispatch("addTukDiscountToOrder", data)
          .then(() => this.successToast("Success!"))
          .catch((err) => this.apiError(err))
          .finally(() => loader.hide());
      });
    },
    showMoreInfo(key) {
      var data = this.t.data;
      if (key === "Fare") {
        if (data.pickup_stop && data.dropoff_stop) {
          this.mapURL = this.directionsURL(data.pickup_stop, data.dropoff_stop);
        } else if (data.address && data.business) {
          this.mapURL = this.directionsURL(data.business, data.address);
        } else return;
        this.moreInfo = "View driving route";
        return;
      }
      // just show coords and link to google location
      var p = null;
      if (key === "Pickup") {
        p = data.pickup_stop;
        this.moreInfo = `Pickup: ${p.lat}, ${p.lon}`;
      }
      if (key === "Dropoff") {
        p = data.dropoff_stop;
        this.moreInfo = `Dropoff: ${p.lat}, ${p.lon}`;
      }
      if (key === "Shop") {
        p = data.business;
        this.moreInfo = `Shop: ${p.lat}, ${p.lon}`;
      }
      if (key === "Address") {
        p = data.address;
        this.moreInfo = `Address: ${p.lat}, ${p.lon}`;
      }
      if (p) this.mapURL = this.googleMapURL(p);
    },
    directionsURL(s, d) {
      var scoords = `${s.lat},${s.lon}`;
      var dcoords = `${d.lat},${d.lon}`;
      return `https://www.google.com/maps?saddr=${scoords}&daddr=${dcoords}`;
    },
    googleMapURL(coords) {
      return `http://www.google.com/maps/place/${coords.lat},${coords.lon}`;
    },
    gotoMapURL() {
      window.open(this.mapURL, "_blank");
    },
    gotoDeviceLocationMapURL() {
      var coords = this.t.data.coords_created;
      var url = `http://www.google.com/maps/place/${coords.lat},${coords.lon}`;
      window.open(url, "_blank");
    },
    // callPhone(e) {
    //   var val = e.target.innerText;
    //   //   console.log("callPhone", val, e.target);
    //   if (val === "Customer") {
    //     this.calling = "Customer: " + this.t.customer.phone_number;
    //     this.callPhoneNumber(this.t.customer.phone_number);
    //   }
    //   if (val === "Driver") {
    //     this.calling = "Driver: " + this.t.driver.phone_number;
    //     this.callPhoneNumber(this.t.driver.phone_number);
    //   }
    //   if (val === "Shop") {
    //     this.preCallShop();
    //     // this.goto(`/shop/${this.t.business_id}?tab=info`);
    //     // this.calling = "from shop profile...";
    //     // this.t.data.agent.phone_number
    //   }
    // },
    callCustomer() {
      this.calling = "Customer: " + this.t.customer.phone_number;
      setTimeout(
        () => this.callPhoneNumber(this.t.customer.phone_number),
        1500
      );
      this.$copyText(this.t.customer.phone_number);
      this.infoToast("Copied " + this.t.customer.phone_number);
    },
    callDriver() {
      this.calling = "Driver: " + this.t.driver.phone_number;
      this.callPhoneNumber(this.t.driver.phone_number);
      this.$copyText(this.t.driver.phone_number);
      this.infoToast("Copied " + this.t.driver.phone_number);
    },
    // this.goto(`/shop/${this.t.business_id}?tab=info`);
    // this.calling = "from shop profile...";
    // this.t.data.agent.phone_number
    notifyShop() {
      // var msg = `TUK Order #${this.t.data.ref} - Please confirm!!! CLICK to accept the order 🦜`;
      var msg = `Please confirm!!! CLICK to accept the order 🦜`;
      var data = {
        workflow_id: this.t.workflow_id,
        title: `🚨TUK NEW ORDER🚨 #${this.t.data.ref}`,
        message: msg,
      };
      var loader = this.loadingDots();
      this.$store
        .dispatch("sendMessageToWorkflow", data)
        .then(() => this.successToast("Shop notified!"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    callShop() {
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
  <i class='fa fa-phone-square-alt'></i>&nbsp;Increment Call Counter?
  </p>
  <p style='text-align:center'>
  ${this.t.data.business.phone_number || "No Phone"}</p>
  </div>`, //   <p>Or go to shop profile without incrementing.</p>
        // showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Increment +1",
        cancelButtonText: "Don't Increment",
      }).then((val) => {
        if (val.dismiss === "backdrop" || val.dismiss === "close") {
          this.$copyText(this.t.data.business.phone_number);
          this.infoToast("Copied " + this.t.data.business.phone_number);
          return;
        }
        if (val.value) this.incrementCallShopCounter();
        if (this.t.data.business.phone_number) {
          this.calling = "Shop: " + this.t.data.business.phone_number;
          setTimeout(
            () => this.callPhoneNumber(this.t.data.business.phone_number),
            1000
          );
          this.$copyText(this.t.data.business.phone_number);
          this.infoToast("Copied " + this.t.data.business.phone_number);
        } else {
          this.goto(`/shop/${this.t.business_id}?tab=info`);
          this.calling = "from shop profile...";
        }
      });
    },
    incrementCallShopCounter() {
      // var name = this.$store.getters.realName;
      // var msg = `☎️ Superuser calling @ ${this.t.data.business.name} 🙋🏻 ${name}`;
      // this.sendSuperuserNotification(msg);
      var loader = this.loadingDots();
      this.$store
        .dispatch("incrementCallShopCounter", this.t.id)
        .then((res) => {
          var callCount = res.data.data.call_shop - 1;
          this.$swal({
            html: `<div style='text-align:left'>
            <p style='margin-bottom:10px'>
              Shop has been called ${callCount} times already for this order
            </p>
            <p style='margin-bottom:10px'>Your call is #${callCount + 1}</p>
            <p>Calling in 2 seconds...</p>
            </div>`,
            timer: 2000,
            showConfirmButton: false,
          });
          // this.updateOrdersCommerceAgent(true);
          // setTimeout(() => this.close(true), 800);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    parseCommerce() {
      var t = this.t;
      var pm = t.data.order.payment_method || "None";
      var paymentMethod = this.translatePayment(pm).toUpperCase();
      var o = {
        Customer: t.customer.name || "Unknown " + t.customer.phone_number,
        Shop: t.data.business.name,
        Fulfilment: t.data.type,
        Order: `<b>฿${t.data.order.order_value}</b> ${paymentMethod}`,
        Created: new Date(t.created_at).toLocaleTimeString("en-GB"),
        Updated: this.timeAgo(t.updated_at),
        // Driver: "No Driver Yet",
      };
      // o.Customer += ` <i class='fa fa-phone is-pulled-right' @click='callCustomer' />`;
      // o.Shop += ` <i class='fa fa-phone is-pulled-right' @click="callShop" />`;
      // o.Shop += ` <i class='fa fa-external-link-alt fa-sm' @click="goto('/shop/'+t.business_id)" />`;
      if (t.data.billing) o.Billing = `฿${t.data.billing}`;
      if (t.data.order.remit) o.Remit = `฿${t.data.order.remit}`;
      if (t.data.type === "delivery") {
        o.Address = t.data.address.name || "Pin Location";
        o.Fare = `฿${t.data.fare.price} (${t.data.fare.cash} cash) ${t.data.fare.distance}m`;
        o.Agent = "No Agent Yet";
        if (t.driver) o.Agent = t.driver.name;
        if (t.data.delivery.is_free_delivery)
          o.Fulfilment += " (Free Delivery)";
        if (t.data.delivery.type) o.Fulfilment += ` - ${t.data.delivery.type}`;
        if (t.data.delivery.delay_duration)
          o.Fulfilment += ` (${t.data.delivery.delay_duration})`;
      }
      if (t.data.delivery && t.data.delivery.promo_code) {
        o.Created += ` <i class='is-pulled-right label'>${t.data.delivery.promo_code} ฿${t.data.order.cashback}</i>`;
      }
      o.Order += ` <a class="is-pulled-right link" href="commerce_order/${t.id}" target="_blank">#${t.data.ref}</a>`;
      if (t.data.order.change_for) {
        o.Order += `<p class="has-text-danger">Change for ฿${t.data.order.change_for}</p>`;
      }
      if (t.data.order.tuk_discount) {
        o.Order += `<p class="has-text-primary">TUK Discount ฿${t.data.order.tuk_discount}</p>`;
      }
      if (t.data.order.basket.notes) o.Notes = t.data.order.basket.notes;
      var lang = this.menuLanguages[this.langIdx];
      t.data.order.basket.items.forEach((item, i) => {
        var name = item.item.name;
        if (item.item[lang]) name = item.item[lang].name;
        var value = `${item.quantity} x ${name} ฿${item.item.price}`;
        if (item.item.discount) {
          // var discount = item.item.discount / 100; // convert from 30 to 0.3
          // var actualPrice = Math.round(item.item.price * (1 - discount)); // round to int
          var actualPrice = this.discountedPrice(item.item);
          if (item.item.discount_type === "number") {
            value += `<br><i class="fa fa-tag fa-sm has-text-danger"></i><i>฿${item.item.discount}</i> = ฿${actualPrice}`;
          } else {
            value += `<br><i class="fa fa-tag fa-sm has-text-danger"></i><i>${item.item.discount}%</i> = ฿${actualPrice}`;
          }
        }
        o[`Item_${i + 1}`] = value;
      });
      if (t.data.start_url)
        o.StartURL = this.shortenString(t.data.start_url, 50);
      if (t.data.ad_tag) o.AdTag = t.data.ad_tag;
      return o;
    },
    parseDelivery() {
      var t = this.t;
      var total = t.data.delivery.order_value + t.data.fare.price;
      var pm = t.data.delivery.payment_method;
      var paymentMethod = this.translatePayment(pm).toUpperCase();
      var o = {
        Customer: t.customer.name || "Unknown " + t.customer.phone_number,
        Pickup: t.data.pickup_stop.name || "Pin Location",
        Dropoff: t.data.dropoff_stop.name || "Pin Location",
        Fare: `฿${t.data.fare.price} (${t.data.fare.cash} cash) ${t.data.fare.distance}m`,
        Order: `฿${t.data.delivery.order_value} ${paymentMethod}`,
        Collect: `<strong>฿${total}</strong>`,
        Created: new Date(t.created_at).toLocaleTimeString("en-GB"),
        Updated: this.timeAgo(t.updated_at),
        Driver: "No Driver Yet",
      };
      if (t.data.delivery.is_free_delivery) o.Order += " (Free Delivery)";
      if (t.driver) {
        o.Driver = `<span class='link' @click='changeDriver(t)'>${t.driver.name}</span>`;
      }
      o.Customer += ` <i class='fa fa-phone is-pulled-right' />`;
      o.Driver += ` <i class='fa fa-phone is-pulled-right' />`;
      return o;
    },
    parseTransport() {
      var t = this.t;
      var o = {
        Customer: t.customer.name || "Unknown " + t.customer.phone_number,
        Pickup: t.data.pickup_stop ? t.data.pickup_stop.name : "Dropoff Only",
        Dropoff: t.data.dropoff_stop ? t.data.dropoff_stop.name : "Pickup Only",
        Fare: "Free of Charge",
        Created: new Date(t.created_at).toLocaleTimeString("en-GB"),
        Updated: this.timeAgo(t.updated_at),
        Driver: "No Driver Yet",
      };
      if (t.data.fare)
        o.Fare = `฿${t.data.fare.price} (${t.data.fare.cash} cash) ${t.data.fare.distance}m`;
      if (t.driver) o.Driver = t.driver.name;
      return o;
    },
    preChangeToAutoconfirm() {
      var title = "Change to autoconfirm";
      var text = "Shop still needs to confirm to call driver.";
      this.$swal({
        html: `<div style='text-align: left'>
        <p style='font-size:1.2em'>
        <i class='far fa-hourglass'></i>&nbsp;${title}</p>
        <p style='margin-top:10px'>${text}</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: "Autoconfirm",
      }).then((val) => {
        if (val.value) {
          this.changeToAutoconfirm();
        }
      });
    },
    changeToAutoconfirm() {
      sounds("mystery_short");
      var loader = this.loadingDots();
      this.$store
        .dispatch("changeCommerceOrderToAutoconfirm", this.t.id)
        .then(() => {
          this.$emit("update");
          this.$emit("close");
          this.infoToast("Commerce order is now on autoconfirm");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    preAssignDriver() {
      var text = "Assign driver (before delivery created only)";
      this.$swal({
        html: `<div style='text-align: left'>
        <p style='font-size:1.2em'>
        <i class='fa fa-motorcycle'></i>&nbsp;${text}</p>
        </div>`,
        input: "text",
        inputValue: this.deliveryPromoCode,
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: this.$t("submit"),
      }).then((val) => {
        if (!val.value) return;
        var driver = val.value.toLowerCase();
        if (codes.lookup(driver)) driver = codes.lookup(driver);
        this.log("commerce_superuser_assign_driver", driver);
        this.infoToast("Assign driver: " + driver);
        this.assignDriver(driver);
      });
    },
    assignDriver(driverPhoneNumber) {
      sounds("mystery_short");
      var loader = this.loadingDots();
      this.$store
        .dispatch("assignDriverToCommerceOrder", {
          transactionID: this.t.id,
          driverPhoneNumber: driverPhoneNumber,
        })
        .then(() => {
          this.$emit("update");
          this.$emit("close");
          this.infoToast("We are assigning the delivery driver 🏍");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    restartCommerce() {
      var t = this.t;
      this.retrying = true;
      sounds("mystery_long");
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: "initiated", data: { retry: true } },
        })
        .then(() => {
          this.$emit("update");
          this.$emit("close");
          this.infoToast("Restarting the order...");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    retryDelivery() {
      var t = this.t;
      this.retrying = true;
      sounds("mystery_long");
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: t.id,
          data: { state: "initiated", data: { retry: true } },
        })
        .then(() => {
          this.$emit("update");
          this.$emit("close");
          this.infoToast("We are retrying the delivery request 🤞🏽");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    preSoftDelete() {
      var title = "Delete Transaction";
      var text = "Please be careful.";
      this.$swal({
        html: `<div style='text-align: left'>
        <p style='font-size:1.2em'>
        <i class='fa fa-bomb' style='color:red'></i>&nbsp;${title}</p>
        <p style='margin-top:10px'>${text}</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "YES, Delete!!!",
        cancelButtonText: "NO, Don't Delete",
        confirmButtonColor: this.bulmaColor("danger"),
        cancelButtonColor: this.bulmaColor("success"),
      }).then((val) => {
        if (val.value) this.softDelete();
      });
    },
    softDelete() {
      // api should toggle is_deleted flag, so if deleted will un-delete too
      var loader = this.loadingDots();
      this.$store
        .dispatch("deleteTransaction", this.t.id)
        .then(() => {
          this.$emit("update");
          this.$emit("close");
          this.infoToast("Deleted!");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    undelete() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("undeleteTransaction", this.t.id)
        .then(() => {
          this.$emit("update");
          this.$emit("close");
          this.infoToast("Un-Deleted!");
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  /* z-index higher than modal */
  background-color: black;
  overflow: hidden;
}

.bg-Delivery {
  background-color: rgb(15, 0, 114);
}

.bg-Commerce {
  background-color: rgb(0, 92, 8);
}

.wrapper {
  text-align: left;
  height: 100vh;
}

.call-wrapper p {
  background-color: white;
  /* border-radius: 4px; */
  margin-bottom: 6px;
  padding: 10px 4px;
}

.call-wrapper p .fa {
  width: 30px;
  text-align: center;
}

.table-wrapper {
  overflow: scroll;
  max-height: calc(100vh - 62px);
  padding-bottom: 160px;
}

.table {
  margin-bottom: 10px;
  background-color: #333;
  color: snow;
}

.table td {
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
}

/* .subtitle {
  color: lightcyan;
  font-weight: 450;
} */
.header {
  padding: 16px;
  /* padding: 2px; */
  font-size: 1.2em;
  font-weight: 450;
  /* margin-bottom: 10px; */
  color: white;
}

.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  background-color: #333;
}

.warning {
  color: black;
  background-color: rgb(255, 143, 143);
  padding: 10px;
  font-weight: 500;
}

.calling {
  margin-bottom: 10px;
  background-color: lightgoldenrodyellow;
  padding: 4px;
  border-radius: 3px;
}

.calling span {
  margin-right: 4px;
}

.key {
  font-weight: 550;
  /* color: rgba(84, 84, 84, 0.7); */
  color: rgba(255, 250, 250, 0.3);
  padding-right: 0;
}

.value {
  /* max-width: calc(100); */
  overflow-wrap: anywhere;
}

.tag {
  padding: 6px;
}

.more-info {
  /* padding: 10px 6px;
  margin-top: -10px;
  color: cyan; */
  color: black;
  background-color: var(--info);
  padding: 10px;
  font-weight: 500;
}

.fa-external-link-alt {
  padding: 4px;
}

.align-top {
  vertical-align: top;
}

/* .link {
  border-bottom: 1px #ccc dotted;
} */
.bg-test {
  background-color: #2f2d21;
  opacity: 1;
  background-image: repeating-linear-gradient(45deg,
      #131312 25%,
      transparent 25%,
      transparent 75%,
      #131312 75%,
      #131312),
    repeating-linear-gradient(45deg,
      #131312 25%,
      #2f2d21 25%,
      #2f2d21 75%,
      #131312 75%,
      #131312);
  background-position: 0 0, 6px 6px;
  background-size: 12px 12px;
}

.bottom-bar {
  position: absolute;
  bottom: 0;
  width: 100vw;
  /* display: flex; */
}

.bottom-bar .button {
  flex: 1;
  border-radius: 0;
  font-size: 1.3em;
  background-color: #444;
  border: 1px solid #666;
  color: #aaa;
  height: 80px;
}

.actions-wrapper {
  background-color: #444;
  padding-bottom: 8px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0 0 7px black;
}

.actions p {
  background-color: #222;
  padding: 9px;

  margin-bottom: 8px;
}

.actions .fa-chevron-right {
  float: right;
  margin-top: 4px;
}
</style>